import { getElement, getElements } from '../../utils/functional'
import Drawer from './drawer'
import { Listeners } from '../_helpers'
import { disableBodyScroll, clearAllBodyScrollLocks } from 'body-scroll-lock';

const matches = {
  trigger: '[data-module-drawers-trigger]',
  close: '[data-module-drawers-close]',
  backdrop: '.js-Drawers_Backdrop'
}
const els = {
  body: document.body || document.documentElement,
  backdrop: getElement(matches.backdrop),
  drawers: getElement('.drw-Drawers')
}
const classes = {
  activeClass: 'drw-Drawers-active',
  activeDrawerClass: 'drw-Drawer-active',
  siteOverflowed: 'util-SiteOverflowed'
}
const options = {
  openOneAtATime: true
}

const Drawers = {
  init: function init () {
    const keys = getElements(`[data-module-drawers-trigger]`).map(
      el => el.dataset.moduleDrawersTrigger
    )
    const drawers = keys.map(key => this.createDrawer(key))

    this.keys = keys
    this.drawers = drawers
    this.listeners = Object.create(Listeners)

    this.handleClick = this.handleClick.bind(this)

    this.setupListeners()
  },

  createDrawer: function createDrawer (key) {
    const drawer = Object.create(Drawer)
    drawer.init({ key })

    return drawer
  },

  setupListeners: function setupListeners () {
    this.listeners.add(els.body, 'click', this.handleClick)
  },

  handleClick: function handleClick (event) {
    const { target } = event
    const isTrigger = target.closest(matches.trigger) !== null
    const isClose = target.closest(matches.close) !== null
    const isBackdrop = target.closest(matches.backdrop) !== null
    const shouldReturnEarly =
      isTrigger === false && isClose === false && isBackdrop === false

    if (shouldReturnEarly) return

    event.preventDefault()

    if (isTrigger) {
      const trigger = target.closest(matches.trigger)
      const key = trigger.dataset.moduleDrawersTrigger

      if (this.keys.includes(key)) {
        this.activeDrawerKey = key === this.activeDrawerKey ? '' : key
      } else {
        this.drawers.push(this.createDrawer(key))
      }
    }

    if (isClose || isBackdrop) {
      this.activeDrawerKey = ''

      window.closeAllMobileNavDrawers()
    }
  },

  get activeDrawerKey () {
    return this._activeDrawerKey
  },
  set activeDrawerKey (v) {
    this._activeDrawerKey = v

    if (v === '') {
      this.drawers.forEach(d => (d.isOpen = false))
    } else {
      const drawer = this.drawers.find(d => d.key === this._activeDrawerKey)
      drawer.isOpen = true

      if (options.openOneAtATime) {
        this.drawers
          .filter(d => d.key !== this._activeDrawerKey)
          .forEach(d => (d.isOpen = false))
      }
    }

    const allDrawersAreClosed = this.drawers.every(d => d.isOpen === false)
    els.drawers.classList.toggle(classes.activeClass, !allDrawersAreClosed)
  }
}

export default Drawers
